import { Directive, ElementRef, HostListener, OnChanges, Self, SimpleChanges } from '@angular/core';
import { NgControl } from '@angular/forms';
import { SSIMUtils } from '../util/SSIMUtil';

@Directive({
  selector: '[appOperationDays]'
})
export class AppOperationDaysDirective implements OnChanges {

  constructor(@Self() private ngControl: NgControl, private element: ElementRef) { }

  @HostListener('keypress', ['$event']) onKeyPress(evento: KeyboardEvent): boolean {

    const tecla = evento.key;
    const valor: string = this.element.nativeElement.value;
    const long: number = this.element.nativeElement.value.length;

    if (
      tecla !== '1' &&
      tecla !== '2' &&
      tecla !== '3' &&
      tecla !== '4' &&
      tecla !== '5' &&
      tecla !== '6' &&
      tecla !== '7') {
      return false;
    }
    if (this.element.nativeElement.selectionEnd - this.element.nativeElement.selectionStart === long) {
      this.ngControl.control.setValue('');
    } else {
      if (valor.indexOf(tecla) !== -1) { // ya existe valor
        return false;
       }else {
        const firstZero = valor.indexOf('0');
        if (firstZero !== -1) {
          this.ngControl.control.setValue(SSIMUtils.getSSIMOperationDaysFromInputString(valor.replace('0', tecla)));
        }
      }
    }

  }

  @HostListener('focus') onFocus(): void {
    this.element.nativeElement.select();
  }

  @HostListener('change') onChange(): void {
    const value: string = this.element.nativeElement.value;
    if (SSIMUtils.validateSSIMOperationDays(value)) {
      this.ngControl.control.setValue(SSIMUtils.getSSIMOperationDaysFromInputString(value));
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.error(changes);
  }

}
